export default __webpack_public_path__ + "static/media/WEB.1386f450.svg";